<template>
  <div class="portdiv">
    <div class="onediv" v-for="(item, index) in rollovers" :key="item.image_id">
      <div class="square-im" v-on:click="handleClick(item)">
        <transition name="fade">
          <a :href="getPermalink(index, item)" v-on:click.prevent><img v-if="seen" :src="getImageUrl(item)" :alt="getAlt(index, item)"  /></a></transition>
        <div class="hover-alink">
          <small-button large v-on:click="visitPortfolio">{{ $nippets.replace('newsPage.visitPortfolio','fname', firstName )}}</small-button>
        </div>
      </div>
      <div class="sbar-x">
        <div class="sg-artist-name"><ix-router-link :to="portfolioUrl" v-if="index === 0" v-on:click.stop>{{ artist.formatted_name }}</ix-router-link></div>
        <div class="rbox"><like-box :imageId="item.image_id" /></div>
      </div>
    </div>
  </div>
</template>


<script>
//import GreyBar from '@/components/widgets/GreyBar.vue'
//import GreyBar from '@/components/widgets/GreyBarNoDrop.vue'
import LikeBox from '@/components/buttons/LikeBox.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'

export default {
  components: {
    LikeBox
  },
  mixins: [ ViewablePanel ],
  props: {
    artistData: Object,
    pageSettings: String,
    gallery: Object,
    showStyleSpecialists: Boolean
  },
  computed: {
    imageId () {
      return this.artistData.images[0].image_id
    },
    portfolioUrl () {
      if(!this.artist) return ''
      if(this.animation) return '/animators/' + this.artist.portfolio_url
      else return '/artists/' + this.artist.portfolio_url
    },
    firstName: function () {
      if(this.artist) {
        let spl = this.artist.formatted_name.split(' ')
        if(spl.length > 0) return spl[0]
        return this.artist.formatted_name
      }
      return ''
    }
  },
  data: function () {
    return {
      artist: { galleries: [] },
      rollovers: []
    }
  },
  created () {
    if(this.artistData.artist_id){
      this.loadArtist()
    }
  },
  methods: {
    
    loadArtist: async function () {
      if(this.artistData) {
        this.artist = await this.$store.dispatch('fetchArtistById', this.artistData.artist_id)
        this.rollovers = this.artistData.images
        this.setInView()
      }
    },
    getImageUrl: function(item) {
      return this.$k.getImageCrop500(item.url)
    },
    getPermalink: function(index, item)
    {
      if(index == 0) {
        return this.$k.getPortfolioLink(this.artist)
      }
      return this.$k.getImagePermalink(item, this.artist)
    },
    getAlt (index, item) {
      if(index === 0) {
        if(this.artistData.subheads){
          let sh = this.artistData.subheads[this.$store.state.lang]
          if(sh){
            return `${this.artist.formatted_name} ${sh}`
          }
          
        }
        
        let ct = this.artist.country;
        if(ct) {
          return `${this.artist.formatted_name} ${this.gallery.name} Illustrator from ${ct}`
        }
        return `${this.artist.formatted_name} ${this.gallery.name} Illustrator`
      }
      return item.alt || this.artist.formatted_name + ' ' + this.gallery.name
      
    },
    handleClick (item) {
      this.$emit('click', {
        image: item.image_id,
        artist: this.artist})
      let gid = Number(this.artistData.gallery_id)
      this.$apix.post('events/log-gallery-image', { imageid: this.imageId, galleryid: gid})
    },
    visitPortfolio () {
      if(this.artist) {
        this.$ixr.push(this.$k.getPortfolioLink(this.artist))
      }
    }
  },
  watch: {
    artistData: function () {
      if(this.artistData.artist_id) {
        this.loadArtist()
      }
    },
    pageSettings () {
      this.setInView()
    }
  }
}
</script>

<style>

img.main{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  transition:all 0.3s ease;
}
.square-filler{
  position:relative;
  overflow:hidden;
}
.imdiv:hover img.main{
  width:107%;
}


.portdiv{
  display:flex;
  background-color:#efefea;
  padding:10px 0;
  margin-bottom:20px;
  justify-content: space-between;
}

.onediv{
  width:19.5%;
  position:relative;
}

.square-im{
  width:100%;
  cursor:pointer;
  position:relative;
  overflow:hidden;
}

.square-im img{
  width:100%;
}

.sbar-x{
  position:relative;
  min-height:24px;
  display:flex;
  justify-content: space-between;
  margin-top:5px;
}

.sg-artist-name{
  font-size: 20px;
  padding-left:10px;
  font-weight:500;
}

.hover-alink{
  position:absolute;
  bottom:-50px;
  left:0;
  padding:10px;
  background-color:#efefea;
  box-sizing: border-box;
  width:100%;
  transition: all 0.4s ease;
}

.square-im:hover .hover-alink{
  bottom:0;
}

@media screen and (max-width:1300px){
  .onediv{
    width:24.3%;
  }

  .onediv:last-child{
    display:none;
  }
}

@media screen and (max-width:960px){
  .onediv{
    width:33%;
  }

  .onediv:nth-last-child(2){
    display:none;
  }
}

@media screen and (max-width:640px){
  .sg-artist-name{
    font-size: 17px;
  }
  .onediv{
    width:49%;
  }

  .onediv:nth-last-child(3){
    display:none;
  }
}

@media screen and (max-width:420px){
  .onediv{
    width:100%;
  }

  .onediv:nth-last-child(4){
    display:none;
  }
}

</style>
